import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Guid } from '@fitscovery/common/types';
import { AddEventAttendeesResponse, EventAttendeeResponse, EventDeleteResponse, EventDownloadEventAttendeesResponse, EventResponse, EventsResponse, UpdateEventAttendeeResponse } from '../models';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from '../environment-injection';

@Injectable()
export class ApiEventsService {

  constructor(
    @Inject(APP_ENVIRONMENT) private env: Environment,
    private http: HttpClient
  ) { }

  getEventById(eventId: string): Observable<EventResponse> {
    return this.http.get<EventResponse>(`${this.env.azureFunctionsApi.events}/events/${eventId}`);
  }

  getEventsBySubdomain(subdomain: string): Observable<EventsResponse> {
    return this.http.get<EventsResponse>(`${this.env.azureFunctionsApi.events}/partners/${subdomain}/events`);
  }

  createEvent(event: any): Observable<any> {
    return this.http.post<any>(`${this.env.azureFunctionsApi.events}/${event.organizerId}/events`, event);
  }

  updateEvent(event: any): Observable<any> {
    return this.http.put(`${this.env.azureFunctionsApi.events}/events/${event.eventId}`, event);
  }

  duplicateEvent(event: any): Observable<any> {
    return this.http.post(`${this.env.azureFunctionsApi.events}/${event.organizerId}/events/${event.id}/duplicate`, event);
  }

  deleteEvent(eventId: Guid, partnerId: Guid): Observable<EventDeleteResponse> {
    return this.http.delete<EventDeleteResponse>(`${this.env.azureFunctionsApi.events}/${partnerId}/events/${eventId}`);
  }

  getAttendeesWithIdByEventId(eventId: Guid): Observable<EventAttendeeResponse> {
    return this.http.get<EventAttendeeResponse>(`${this.env.azureFunctionsApi.events}/events/${eventId}/attendees`);
  }

  addEventAttendees(eventId: Guid, userList: Guid[]): Observable<AddEventAttendeesResponse> {
    return this.http.post<AddEventAttendeesResponse>(`${this.env.azureFunctionsApi.events}/events/${eventId}/add-attendees`, {
      eventId, userList
    });
  }

  updateEventAttendee(userId: Guid, partnerId: Guid, eventId: Guid, isPresent: boolean): Observable<any> {
    return this.http.put<any>(`${this.env.azureFunctionsApi.events}/partners/${partnerId}/events/${eventId}/user/${userId}/attendance`, {
      eventId, partnerId, userId, isPresent
    });
  }

  updateAllEventAttendee(partnerId: Guid, eventId: Guid, isPresent: boolean): Observable<UpdateEventAttendeeResponse> {
    return this.http.put<UpdateEventAttendeeResponse>(`${this.env.azureFunctionsApi.events}/partners/${partnerId}/events/${eventId}/attendance`, {
      eventId, partnerId, isPresent
    });
  }

  downloadCsvEventAttendees(eventId: Guid, partnerId: Guid): Observable<EventDownloadEventAttendeesResponse> {
    return this.http.get<EventDownloadEventAttendeesResponse>(`${this.env.azureFunctionsApi.events}/partners/${partnerId}/events/${eventId}/attendees/download`);
  }

  bookNow(eventId: Guid, quantity: number): Observable<EventAttendeeResponse> {
    return this.http.post<EventAttendeeResponse>(`${this.env.azureFunctionsApi.events}/events/${eventId}/attendees`, {
      quantity
    });
  }

  softReserve(eventId: Guid): Observable<EventAttendeeResponse> {
    return this.http.post<EventAttendeeResponse>(`${this.env.azureFunctionsApi.events}/events/paid/${eventId}/attendees`, {});
  }

  cancelFreeEventSlot(eventId: Guid): Observable<EventAttendeeResponse> {
    return this.http.put<EventAttendeeResponse>(`${this.env.azureFunctionsApi.events}/events/free/${eventId}/attendees/cancel`, {});
  }

  cancelEventSlot(eventId: Guid): Observable<EventAttendeeResponse> {
    return this.http.put<EventAttendeeResponse>(`${this.env.azureFunctionsApi.events}/events/${eventId}/attendees/cancel`, {});
  }

}
